import React, { FunctionComponent } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../../../../hooks/useTranslation';
import Link from '../../../../text-link';
import { CircularProgress, IconButton } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import colors from '../../../../../themes/main-colors';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginBottom: '15px',
      paddingLeft: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    outageZipcode: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: colors.noirBlur,
    },
    loaderWrapper: {
      paddingBottom: 3,
    },
  }),
);

interface Props {
  selectedZipcode: string | undefined;
  isPrevEnabled: boolean;
  isNextEnabled: boolean;
  handleOutageByZipClick: (show: boolean) => void;
  handleOutageZipChange: (isPrev: boolean) => void;
  isLoading: boolean;
}

const OutageZipCode: FunctionComponent<Props> = ({
  handleOutageByZipClick,
  selectedZipcode,
  isPrevEnabled,
  isNextEnabled,
  handleOutageZipChange,
  isLoading,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      {isLoading ? (
        <div className={classes.loaderWrapper}>
          <CircularProgress />
        </div>
      ) : (
        <div className={classes.outageZipcode}>
          <IconButton
            onClick={() => handleOutageZipChange(true)}
            style={{
              marginRight: '1.2rem',
              color: isPrevEnabled ? 'currentColor' : '',
            }}
            disabled={!isPrevEnabled}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="h2">{selectedZipcode}</Typography>
          <IconButton
            onClick={() => handleOutageZipChange(false)}
            style={{
              marginLeft: '1.2rem',
              color: isNextEnabled ? 'currentColor' : '',
            }}
            disabled={!isNextEnabled}
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
      )}
      <Link
        to={'/'}
        variant="body2"
        onClick={e => {
          e.preventDefault();
          handleOutageByZipClick(true);
        }}
      >
        {t('OUTAGE_LIST_BY_ZIP_CODE')}
      </Link>
    </div>
  );
};

export default OutageZipCode;
